import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** circle exclamation, alert. Decorative line icon; always pair with a visible text label. */
export function AlertIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 8v4.5" />
      <path d="M12 16v.01" />
    </IconSvg>
  )
}
